import React, { Component, Fragment } from 'react';
import PropTypes from "prop-types";
import { _delete,get, patch } from "../../../server/actions";
import $ from 'jquery';
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import { _addNotification, _addNotificationError } from "../../../server/util";
import moment from  'moment';
import {date_format} from "../../../server/constants"
import { Row } from 'react-bootstrap';
import './leadsManagement.css';
class LeadDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            status: "ALL",
            schoolList: [],
            columns: [],
            commentsData:[],
        }
    }

    componentWillMount = () => {
        this.getCommentsHistory();
     
    };
    refreshCommentHistory=()=>{
        this.getCommentsHistory();

    }
    getCommentsHistory=()=> {
        const row=this.props.row.original;
        get(`/leads/history?requestId=${row.requestId}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            const masterRec={...row};
            if(!masterRec.statusCodeId){
                masterRec.statusCodeId=1;
            }
            const mergedData=[...[masterRec],...data.reverse()];
            this.setState({
                commentsData:mergedData,
                loading: false
            })
        }).catch(
            (error) => {
                console.log('Get Leads response', error)
            }
        );
    };
     getStatus(id){
        let status='';
        const row=this.props.row.original;
        let statusInfo=this.props.data;
        Object.values(statusInfo).forEach((key)=>{
            if (key.statusCodeId === id) {
                status=key.statusCodeDesc
            }
        })
        return status;
    }
    render() {
        const {commentsData}=this.state;
        const row=this.props.row.original;
        {
            $('#selector button').click(function () {
                $(this).addClass('active').siblings().removeClass('active');
            })
        }
        return (<Fragment>
            <div className="leadDetails">
                <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>                
                <div className="row" style={{fontSize:'13px'}}>
                    <div className="col-md-11">
                        <label>Name : {row.name}</label>
                    </div><div className='col-md-1 text-right'>
                        <span style={{ cursor: 'pointer', fontSize: '14px'}}
                            onClick={()=>{
                                this.refreshCommentHistory();
                            }}><i
                            className="fa fa-refresh "/></span>                        
                    </div>
                    <div className="col-md-12">
                        <fieldset>
                            <legend>Logs</legend>                            
                            <ul>
                            {
                                commentsData.length>0?
                                commentsData.map(item => (
                                    (item != null)? 
                                    <li>
                                        <strong>
                                            {`${moment(item.updatedOn).format('MM/DD')}: Status changed to ${this.getStatus(item.statusCodeId||'')}.${item.followUpDate?` Follow up changed to: ${moment(item.followUpDate).format('MM-DD-YYYY')}.`:''} ${item.comments?` Comments – ${item.comments}.`:''} ${item.updatedBy?` By- ${item.updatedBy}`:''}`}</strong></li> 
                                     :null))
                                :<li><div className="emptyComments">No Data</div></li>
                            }
                            </ul>
                        </fieldset>
                    </div>
                </div>
            </div> 
           
            {/* <div>
                <NotificationSystem ref="notificationSystem" />
                <section className=" full-width clearfix">
                    <div className='sweet-loading'
                         style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className=" pull-left sectionTitle">
                                <h2 style={{margin: '20px 0px 0px'}}>
                                    <span style={{margin: '10px 10px 0px 0px'}}>Lead Details</span>
                                </h2>
                            </div>
                           
                        </div>
                        <div className="clearfix"></div> 
                        
                        <div className="row col-md-6">
                            <div className="panel panel-primary">
                                <div className="panel-body">
                                <label className="color-3">Name : {row.name}</label>
                                <br />
                                <label className="color-3">School : {row.schoolName} </label> 
                                <br />
                                <label className="color-3">Email : {row.emailAddress}</label> 
                                <br />
                                <label className="color-3">Phone : {row.mobileNo}</label> 
                                <br />
                                <label className="color-3">Date of lead : {moment(row.createdOn).format('YYYY-MM-DD'+' , '+'hh:mm:ss a')}</label> 
                                <br />

                                <label className="color-3">Status : {this.getStatus()}
                                </label> 
                                <br />
                                <label className="color-3">Date of action : {row.dateOfAction}</label>  
                                <br />
                                <label className="color-3">Follow up date : {row.followUpDate}</label>  
                                <br />
                                    <label className="color-3">COMMENTS :  
                                   
                                    {
                                commentsData.map(item => (
                                    (item != null)?
                                    (item.comments && 
                                        <div className="media">
                                            <div className="media-left">
                                                <a href="javascript:void(0)">
                                                    <img className="media-object" style={{width:'50px', height:'40px'}} src="data:image/png;base64,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" alt="..." />
                                                </a>
                                            </div>
                                            <div className="media-body">
                                                <h4 className="media-heading" style={{textTransform: 'none',fontSize: '13px', fontWeight:'700'}}>{`${(row.updatedBy||'')} on ${moment(item.updatedOn).format('YYYY-MM-DD'+' , '+'hh:mm:ss a')}`} </h4>
                                                <p>{item.comments}</p>
                                            </div>
                                        </div>     
                                    )
                                     :null))
                                     }     
                                     </label>  
                                    <br />     
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div> */}

            </Fragment>
        );
    }
}
LeadDetails.contextTypes = {
    router: PropTypes.object.isRequired
}
export default LeadDetails;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Schools/leadDetails.jsx